const MeauxminyCollabsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://soundcloud.com/anjuonline/rainbow-bodega" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-U4RGgfX5Ay7tVLOM-3ygPMg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>ANJU Online! - Rainbow Bodega</strong><br/>
              (prod. ANJU Online! & Meauxminy)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default MeauxminyCollabsStatic;